import React from 'react';
import PropTypes from 'prop-types';

import { Grid, ThemeConstellation } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import ProgressBar from '../ProgressBar';

import { StyledGrid, StyledMobileGrid } from './StyledComponents';

/*
 * ProgressStepper
 *
 * usage example:
    <ProgressStepper activeIndex={1} isMobile={isMobile}>
        <Step label="Find Listings" mobileLabel="Find" />
        <Step label="Verify to claim" mobileLabel="Verify" />
        <Step label="Convert to ZRM" mobileLabel="Convert" />
    </ProgressStepper>
*/

const propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  activeIndex: PropTypes.number,
  alwaysShowProgressMeterTitle: PropTypes.bool,
  left: PropTypes.number.isRequired,
  right: PropTypes.number.isRequired,
  currentProgressStepLabel: PropTypes.string.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  isWizardComplete: PropTypes.bool,
  totalSteps: PropTypes.number.isRequired,
  showDesktopViewBreakpoint: PropTypes.oneOf(Object.keys(ThemeConstellation.ns().breakpoints)).isRequired,
};

const defaultProps = { activeIndex: -1, alwaysShowProgressMeterTitle: false, isWizardComplete: false };

const ProgressStepper = ({
  children,
  activeIndex,
  alwaysShowProgressMeterTitle,
  left,
  right,
  currentProgressStepLabel,
  currentStepIndex,
  isWizardComplete,
  totalSteps,
  showDesktopViewBreakpoint,
}) => {
  const childrenArray = React.Children.toArray(children);
  const steps = childrenArray.map((step, index) => {
    const newStep = React.cloneElement(step, {
      ...step.props,
      index,
      activeIndex,
      isActive: step.props.isActive || index === activeIndex,
      isCompleted: step.props.isCompleted || index < activeIndex,
      isWizardComplete,
      showDesktopViewBreakpoint,
    });

    return (
      <StyledGrid key={`step-container-${index}`} role="listitem">
        {index !== 0 && <ProgressBar isActive={index <= activeIndex} left={left} right={right} />}
        {newStep}
      </StyledGrid>
    );
  });
  return (
    <>
      <Grid role="list" display="grid" gridTemplateColumns="repeat(auto-fit, minmax(0, 1fr))">
        {steps}
      </Grid>
      <StyledMobileGrid
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(0, 1fr))"
        marginLeft="sm"
        showDesktopViewBreakpoint={showDesktopViewBreakpoint}
        alwaysShowProgressMeterTitle={alwaysShowProgressMeterTitle}
      >
        <Grid>
          <Text textStyle="body-sm-bold">{currentProgressStepLabel}</Text>
          {currentProgressStepLabel && <Text textStyle="body-sm">{` (${currentStepIndex}/${totalSteps})`}</Text>}
        </Grid>
      </StyledMobileGrid>
    </>
  );
};

ProgressStepper.propTypes = propTypes;
ProgressStepper.defaultProps = defaultProps;

export { ProgressStepper };
export default ProgressStepper;
